import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import formatTonnage from '/shared/functions/formatTonnage';

import getElectDecoratedLocationsSelector from '/business/shared/state/selectors/application/electricityHeatSteam/getElectDecoratedLocationsSelector';

// import StyledTopEmissionsTable from './__styled__/StyledTopEmissionsTable';

function TopEmissionsTable() {
  const { t } = useTranslation();
  const locations = useSelector(getElectDecoratedLocationsSelector);

  // @todo: Should probably be selector
  const locationsSorted = [...locations]
    .filter((location) => location.aggregated_tonnage && location.aggregated_tonnage > 0)
    .sort((a, b) => (b.aggregated_tonnage || 0) - (a.aggregated_tonnage || 0))
    .slice(0, 5);

  if (!locationsSorted || locationsSorted.length === 0) {
    return <p>{t('questions:electricityHeatSteam.components.topEmissionsTable.noEmissionsData')}</p>;
  }

  return (
    <table>
      <tbody>
        {locationsSorted.map((location) => (
          <tr key={location.unique_name}>
            <td>{location.unique_name}</td>
            <td>
              <strong>{formatTonnage(location.aggregated_tonnage)}</strong>
              <br />
              <div>{t('business:emissionFactors.emissionUnits.tonnageRaw')}</div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default TopEmissionsTable;
